export default "__VITE_ASSET__EHxLwvn7__"